














































































































































































































































import { filterMixin } from '@/utils/mixins/filterMixin'
import RangeDatePicker from '@/components/RangeDatePicker.vue'
import { DatePicker, Params, PaymentMethods } from '@/utils/interfaces'
import { getAgencies, getClients } from '@/api/Agency/agency.api'
import Autocomplete from '@/components/Autocomplete.vue'
import { RemittanceStatus } from '@/utils/RemittanceStatus.constants'
import { chipClasses } from '@/utils/chipClasses.constant'
import { getRegions, getSubregions } from '@/api/Address/address'
import { getUsers } from '@/api/Users/users.api'
import { Roles } from '~/plugins/permissions'
import UserListItem from '~/components/UserListItem.vue'
import FlatFilter from '~/components/FlatFilter.vue'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'

export default filterMixin.extend({
  components: {
    appRangeDatePicker: RangeDatePicker,
    appAutocomplete: Autocomplete,
    UserListItem,
    FlatFilter,
  },
  props: {
    yours: Boolean,
  },
  data() {
    const paymentMethodItems = Object.values(PaymentMethods).map(
      (value: string) => ({
        value,
        text: this.$t(value),
      }),
    )
    return {
      DeliveryCurrenciesEnum,
      paymentMethodItems,
      status: RemittanceStatus.map(status => ({
        value: status,
        text: this.$t(status),
      })),
      getMessengers: (params?: Params) =>
        getUsers({ ...params, services__name: 'REMITTANCE' }),
      getDeliveryMessengers: (params?: Params) =>
        getUsers({
          ...params,
          services__name: 'REMITTANCE',
          role: Roles.AGENT,
        }),
      getAgencies: getAgencies,
      getClients: getClients,
      tags: [
        {
          value: 'AGENT',
          text: this.$t('yours'),
        },
        {
          value: 'AGENCY',
          text: this.$t('of-network'),
        },
      ],
      chipClasses: chipClasses,
      owner: 0,
      getRegion: (params?: Params) =>
        getRegions({ ...params, country__name: 'Cuba' }),
      getSubregion: (params?: Params) =>
        getSubregions({ ...params, country__name: 'Cuba' }),
      booleanItems: [
        {
          text: this.$t('yes'),
          value: 'true',
        },
        {
          text: this.$t('no'),
          value: 'false',
        },
      ],
    }
  },
  methods: {
    newFilter() {
      const dates = (this.$refs.datePicker as DatePicker).getData()
      const deliveryDates = (this.$refs.deliveryPicker as DatePicker).getData()
      const assignment = (this.$refs.assignmentPicker as DatePicker).getData()
      const filter = {
        ...this.filter,
        created_at__gte: dates.minDate,
        created_at__lte: dates.maxDate,
        remittance__assignment_at__gte: assignment.minDate,
        remittance__assignment_at__lte: assignment.maxDate,
        remittance__delivered_at__gte: deliveryDates.minDate,
        remittance__delivered_at__lte: deliveryDates.maxDate,
        remittance__delivery_currency__in: (
          this.filter.remittance__delivery_currency__in || []
        ).join(','),
      } as { [key: string]: any }
      this.$emit('filter', filter)
    },
  },
})
